var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{staticClass:"state_modal",attrs:{"width":"350","value":_vm.value},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-card',[_c('v-card-title'),_c('v-card-text',[_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.text)+"がありません")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }